import React from 'react';
import styles from './YAxisValues.module.scss';

type YValue = {
  value: string | number;
  visible: boolean;
};

type YValuesGroup = {
  value: YValue[];
};

type YValues = {
  positive: YValuesGroup;
  negative: YValuesGroup;
};

type YAxisValuesProps = {
  yValues: YValues | false;
};

const YAxisValues: React.FC<YAxisValuesProps> = ({ yValues }) => {
  if (!yValues) {
    return null; // Equivalent to `v-if="yValues"` in Vue
  }

  return (
    <div className={styles['y-values-groups']}>
      {/* Positive Values Group */}
      <div className={`${styles['y-values-group']} ${styles['y-values-group--positive']}`}>
        {yValues.positive.value.map((yValue) => (
          <div
            key={yValue.value}
            className={`${styles['y-value']} body-small ${
              !yValue.visible ? styles['y-value--hidden'] : ''
            }`}
          >
            <span>{yValue.value}</span>
          </div>
        ))}
        <div className={`${styles['y-value']} body-small ${styles['y-value--zero']}`}>0</div>
      </div>

      {/* Negative Values Group */}
      {yValues.negative.value.length > 0 && (
        <div className={`${styles['y-values-group']} ${styles['y-values-group--negative']}`}>
          {yValues.negative.value.map((yValue) => (
            <div
              key={yValue.value}
              className={`${styles['y-value']} body-small ${
                !yValue.visible ? styles['y-value--hidden'] : ''
              }`}
            >
              <span>{yValue.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default YAxisValues;
